import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';

import { UserService } from './user.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(public router: Router, public userService: UserService) {
  }

  canActivate(route: ActivatedRouteSnapshot) {
    return new Promise((resolve, reject) => {
      if (!localStorage.getItem('auth_access_token')) {
        return resolve(this.redirectToLogin());
      }

      this.userService.getProfile()
      .then(() => {
        resolve(this.checkRole(route.data));
      });
    });
  }

  checkRole(data) {
    if (!data || !data.roles) {
      return true;
    }

    let activate = this.userService.hasRole(data.roles);
    if (!activate) {
      this.redirectToLogin();
    }
    return activate;
  }

  redirectToLogin() {
    this.router.navigate(['/login']);
    localStorage.removeItem('auth_access_token');
    localStorage.removeItem('auth_expires_in');
    localStorage.removeItem('auth_refresh_token');
    localStorage.removeItem('auth_scope');
    localStorage.removeItem('auth_token_type');
    return false;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/common/services/guard.service.ts